import { Component, Input } from '@angular/core';

export interface OwnerPreviewMetaItem {
	icon: string;
	label: string;
}

@Component({
	selector: 'app-owner-preview',
	templateUrl: './owner-preview.component.html',
	styleUrls: ['./owner-preview.component.scss']
})
export class OwnerPreviewComponent {
	@Input() name = '';
	@Input() avatarUrl?: string | null;
	@Input() meta: OwnerPreviewMetaItem[] = [];
	@Input() size: 'sm' | 'md' = 'sm';
	@Input() showPlaceholderLabel = true;
	@Input() placeholderIcon = 'fal fa-image';
	@Input() inSummaryOwnerCard = false;

	get resolvedName(): string {
		return this.name?.trim() || 'Unknown owner';
	}

	get hasAvatar(): boolean {
		return Boolean(this.avatarUrl);
	}
}
